import styled from 'styled-components';
import { PopperWrapper } from '@mlb/react-patterns/components/Popover/popover.style';
import COLORS from '@mlb/react-patterns/style/universal.color.ts';
import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints';
import { IconWrapper } from '@mlb/react-patterns/components/AccordionItem/AccordionItem.style';

const {
    sm
} = BREAKPOINTS;
const {
    mlbGrey5,
    mlbWhite,
    mlbGrey2,
    mlbBlack
} = COLORS;

export const HeaderWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    height: 50px;
    box-sizing: border-box;
    padding-top: 14px;
    padding-bottom: 12.5px;
    border-bottom: 1px solid var(--gameday-divider-color);
    margin-bottom: 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    background-color: var(--gameday-background-color);

    @media (max-width: ${sm}) {
        margin-bottom: 0;
    }

    button {
        display: inline-block;
        height: 100%;
        cursor: pointer;
        padding: 0;
        background: transparent;
        &[disabled] {
            pointer-events: none;
        }

        svg {
            height: auto;
            fill: ${mlbGrey5};
            stroke: ${mlbGrey5};
        }


        &:hover,
        &.btn-active  {
            background: transparent;
            svg {
                path {
                    fill-rule: nonzero;
                }
            }
        }
    }
  
    ${PopperWrapper} {
        z-index: 120;
        left: auto !important;
        right: 12px !important;
        top: 35px !important;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        transform: none !important;
        background-color: var(--gameday-background-color);
        border: 1px solid var(--gameday-header-menu-border-color);
    }
`;

export const ItemWrapper = styled.div`
    flex: 1 1 1%;
    display: inline-block;
    height: 100%;
    vertical-align: middle;
`;

export const MoreWrapper = styled(ItemWrapper)`
    text-align: right;
    span {
        margin-right: 8px;
        height: 100%;
    }

    svg {
        stroke-width: 0;
    }
`;

export const LogoWrapper = styled(ItemWrapper)`
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    a {
        margin-left: 16px;
        max-height: 30px;
    }

    .header-logo {
        height: 30px;
        width: 55px;
        img {
            object-fit: contain;
            object-position: left 50%;
            max-width: 100%;
            height: auto;
            max-height: 30px;
        }
    }
`;

export const TitleWrapper = styled(ItemWrapper)`
    text-align: center;
    color: var(--gameday-scaffold-header-title-color);
    height: 18px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    svg {
        fill: var(--gameday-scaffold-header-title-color);
        path {
            fill: var(--gameday-scaffold-header-title-color);
        }
    }
`;

export const ScoreboardButtonWrapper = styled(IconWrapper)`
    transform-origin: 50% 50%;
    transform: ${({ iconRotated }) => iconRotated ? 'translateX(-50%) rotate(180deg)' : 'translateX(-50%) rotate(0)'};
    opacity: 1;
    cursor: pointer;
    border-radius: 0;
    background: transparent;
    margin-left: 10px;
    box-shadow: none;
    svg {
        fill: var(--gameday-scoreboard-button-color);
    }
    
`;
